module.exports = "<div style=\"border-radius: 3px; border: 2px dashed #F1F2F5; padding: 16px;\">\n  <h3>{{ element?.label }}</h3>\n</div>\n"